import { Transform } from 'class-transformer';
import { dateTransform } from '../utils/helper';

export class InsDate {
    @Transform(dateTransform)
    insdate!: Date;
}

export class ModDate {
    @Transform(dateTransform)
    moddate!: Date;
}

export class InsModDate extends InsDate {
    @Transform(dateTransform)
    moddate!: Date;
}
